import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $toggleBtn: this.el._$('.section-nav__btn')
    };

    this.expandedClass = 'section-nav--expanded';
  }

  addListeners() {
    this.dom.$toggleBtn._on('click', this.toggleExpand.bind(this));
  }

  toggleExpand(e) {
    this.el.classList.toggle(this.expandedClass);
  }
}

export default Module;
